module.exports = __webpack_public_path__ + "img/morning-and-evening-usage-icon.04fb386e.svg";